<template>

<div class="Log_in bg-image">

  <div class="row g-0 mt-4">

    <div class="col-md-7">
     
      <div class="formbg card bg-light" style="border-radius: 15px;">
          <div class="formbg-inner m-4">

              <div class="row mt-2 mb-2">
                <div class="col-md-12">
                  <div class="text-center">
                    <h4>Espace utilisateur</h4>
                    <div class="mt-3 px-5">
                      <small>
                        <p>Veuillez renseigner vos identifiants de connexion dans les champs ci-dessous.</p>
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <form class="py-3 p-5" @submit.prevent="handleLogin">
                  <div class="field pb-3">
                      <label for="phone">N° de Téléphone</label>
                      <input class="form-control" v-model="phone" type="text" name="phone" required>
                  </div>
                  <div class="field pb-3">
                      <div class="grid--50-50">
                          <label for="password">Mot de passe</label>
                      </div>
                      <input class="form-control" v-model="password" type="password" name="password" required>
                      <div class="reset-pass mt-2">
                        <router-link to="/reinitialisation-de-mot-de-passe" style="color: #61C7F2 !important; font-size: 12px !important; text-decoration: underline !important;">Mot de passe oublié ?</router-link>
                      </div>
                  </div>
                  <div class="field padding-bottom--24">
                    <button v-if="loading" disabled class="btn btn-dark w-100" style="background: #c3c3c3; color: #FFFFFF;">Opération en cours ...</button>
                    <button v-else type="submit" class="btn btn-warning w-100" style="background-color: #F7A51B !important; color: #FFFFFF">Connexion</button>
                  </div>
              </form>

              <div class="row" style="gap: 0 !important;">
                <div class="col-lg-6 mt-1">
                  <div class="text-center">
                    <router-link to="/">
                      <button type="button" class="btn btn-sm btn-outline-warning w-100">
                        <font-awesome-icon icon="home" />&nbsp;&nbsp;Accueil
                      </button>
                    </router-link>
                  </div>
                </div>

                <div class="col-lg-6 mt-1">
                  <div class="text-center">
                    <router-link to="/page-creation">
                      <button type="button" class="btn btn-sm btn-outline-info w-100">
                        <font-awesome-icon icon="user-plus" />&nbsp;&nbsp;Inscription
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>

          </div>
      </div>
        
    </div>

    <div class="col-md-5"></div>

  </div>

</div>



</template>

<script>
import { useToast } from "vue-toastification";
export default {
  name: 'Login',

  data() {
    return {
      loading: false,
      phone: null,
      password: null
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      var data = {
        phone: '225' + this.phone,
        password: this.password
      }
      await this.$store.dispatch("auth/login", data)
      .then(
        (response) => {
          this.loading = false;
          if (response.success) {
            this.toast.success(response.message, {
              position: "top-right",
              timeout: 2000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
            this.$router.push('/')
          }
        },
        (error) => {
          this.toast.error(error.response.data.message, {
            position: "top-center",
            timeout: 2500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
          this.loading = false;
        }
      );
    }
  }
}
</script>

<style scoped>

h1 {
  letter-spacing: -1px;
}
a {
  color: #61C7F2;
  text-decoration: unset;
}

.card {
  margin: 0px auto;
  width: 100%;
  max-width: 448px;
  background: white !important;
  border-radius: 4px;
  box-shadow: rgba(60, 66, 87, 0.12) 0px 7px 14px 0px,
    rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
}
span {
  display: block;
  font-size: 20px;
  line-height: 28px;
  color: #1a1f36;
}
label {
  margin-bottom: 10px;
}
.reset-pass a,
label {
  font-size: 14px;
  font-weight: 600;
  display: block;
}
.reset-pass > a {
  text-align: right;
  margin-bottom: 10px;
}
.grid--50-50 {
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
}

.bg-image {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(
      rgba(47, 128, 237, 0.45),
      rgba(47, 128, 237, 0.45)
    ),
    url(../../assets/img/bgmetier.png);
  background-size: cover;
  background-position: center;
}


</style>